import api from '../api';
import { ECRI_ACTIONS } from '../constants';

export const addComment =
  ({ priceId, comment, user, store }) =>
  (dispatch) => {
    dispatch({
      type: 'SET_COMMENTS_LOADING',
      payload: true,
    });
    api
      .addComment({
        priceId,
        // unitId:data.UnitId,
        comment,
      })
      .then((res) => {
        dispatch({
          type: 'ADD_COMMENT',
          payload: {
            priceId,
            comment,
            user,
            store,
          },
        });
      })
      .catch((err) => {
        if (err.response.status === 401)
          dispatch({
            type: 'LOGOUT',
          });
        else
          dispatch({
            type: 'API_ERROR',
          });
      });
  };
export const raiseAlert = (data) => (dispatch) => {
  api
    .raiseAlert({
      priceId: data.id,
      store: data.Store,
      comment: 'this is an alert test comment',
    })
    .then((res) => {
      console.log(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401)
        dispatch({
          type: 'LOGOUT',
        });
      else
        dispatch({
          type: 'API_ERROR',
        });
    });
};

export const fetchComments =
  ({ priceId }) =>
  (dispatch) => {
    api
      .fetchComments({ priceId })
      .then((res) => {
        dispatch({
          type: 'FETCH_COMMENTS',
          payload: { priceId, comments: res.data.comments },
        });
      })
      .catch((err) => {
        if (err.response.status === 401)
          dispatch({
            type: 'LOGOUT',
          });
        else
          dispatch({
            type: 'API_ERROR',
          });
      });
  };

export const toggleCommentsDialog = (item) => (dispatch) =>
  dispatch({
    type: 'TOGGLE_COMMENTS_DIALOG_VISIBILITY',
    payload: item,
  });

const formatNotification = (notifications) => {
  let formattedNotifications = notifications.map((e) => {
    let { data } = e;
    let date = new Date(e.CreatedOn).toLocaleString();
    let formattedNotification = {
      date,
      read: e.read,
      id: e.id,
      data: {
        ...e,
        isToday:
          new Date().toLocaleString().split(',')[0] === date.split(',')[0],
      },
    };
    if (!data) return null;
    switch (e.Type) {
      case 'price_override': {
        let comment = '.';
        if (data?.comment && data.comment.Comment) {
          comment = ` with comment "${data.comment.Comment}".`;
        }
        let summary = `${data.override.CreatedBy} updated price to ${data.override.OverriddenPrice} and created new price overide rule for ${data.override.OverrideDays} days${comment}`;
        let extraText = `Store: ${e.Store} | Unit Type: ${data.UnitType} | UnitSize: ${data.UnitSize} `;
        return {
          summary,
          extraText,
          ...formattedNotification,
        };
      }
      case 'price_update': {
        let comment = '.';
        if (data?.comment && data.comment.Comment) {
          comment = ` with comment "${data.comment.Comment}".`;
        }
        return {
          summary: `${data.UserName} updated price from ${data.PreviousPrice} to ${data.NewPrice}${comment}`,
          extraText: `Store: ${e.Store} | Unit Type: ${data.UnitType} | UnitSize: ${data.UnitSize} `,
          ...formattedNotification,
        };
      }
      case 'comment': {
        return {
          summary: `${data.UserName} added comment "${data.Comment}"`,
          extraText: `Store: ${e.Store} | Unit Type: ${data.UnitType} | UnitSize: ${data.UnitSize} `,
          ...formattedNotification,
        };
      }
      case 'alert': {
        let comment = '.';
        if (data?.comment && data.comment.Comment) {
          comment = ` with comment "${data.comment.Comment}".`;
        }
        return {
          summary: `${data.UserName} raised Alert${comment}`,
          extraText: `Store: ${e.Store} | Unit Type: ${data.UnitType} | UnitSize: ${data.UnitSize} `,
          ...formattedNotification,
        };
      }
      case 'freeze_price': {
        return {
          summary: `Prices for Store ${e.Store} have been freezed by ${data.CreatedBy}`,
          extraText: `Prices Freezed | Store: ${e.Store}`,
          ...formattedNotification,
        };
      }
      case 'suggest_price': {
        let comment = '.';
        if (data?.comment && data.comment.Comment) {
          comment = ` with comment "${data.comment.Comment}".`;
        }
        return {
          summary: `${data.CreatedBy} suggested price from £${data.OldPrice} to £${data.SuggestedPrice}${comment}`,
          extraText: `Store: ${e.Store} | Unit Type: ${data.UnitType} | UnitSize: ${data.UnitSize} `,
          ...formattedNotification,
        };
      }
      case 'approve_suggestion': {
        let comment = '.';
        if (data?.comment && data.comment.Comment) {
          comment = ` with comment "${data.comment.Comment}".`;
        }
        return {
          summary: `${data.ApprovedBy} updated price from £${data.OldPrice} to £${data.SuggestedPrice}${comment}`,
          extraText: `Store: ${e.Store} | Unit Type: ${data.UnitType} | UnitSize: ${data.UnitSize} `,
          ...formattedNotification,
        };
      }
      case 'suggest_discount': {
        return {
          summary: `${data.CreatedBy} suggested discount change from "${data.OldDealTitle}" to "${data.NewDealTitle}"`,
          extraText: `Store: ${data.StoreName} | Unit Type: ${data.UnitType} | UnitSize: ${data.UnitSize} `,
          ...formattedNotification,
        };
      }
      case 'override_discount': {
        return {
          summary: `${data.UserName} overrode discount from "${
            data.PreviousNewDiscount
          }" to "${data.UpdatedNewDiscount}" for ${
            Number(data.Duration) === 0 ? '1 week' : `${data.Duration} ${Number(data.Duration) > 1 ? 'months' : 'month'}`
          } with reason "${data.Reason}" ${
            data.Comment ? `and comment "${data.Comment}"` : ''
          }`,
          extraText: `UnitId: ${data.UnitId} | Unit Type: ${data.UnitType} | UnitSize: ${data.UnitSize} `,
          ...formattedNotification,
        };
      }
      case 'approve_discount_suggestion': {
        return {
          summary: `${data.ApprovedBy} approved discount change from "${data.OldDealTitle}" to "${data.NewDealTitle}"`,
          extraText: `Store: ${data.StoreName} | Unit Type: ${data.UnitType} | UnitSize: ${data.UnitSize} `,
          ...formattedNotification,
        };
      }
      case 'suggest_ecri_price': {
        return {
          summary: `${data.CreatedBy} suggested ECRI price change from £${data.OldPrice} to £${data.SuggestedPrice}`,
          extraText: `Store: ${data.StoreName} | Tenant: ${data.TenantName} | Unit: ${data.s_unit} `,
          ...formattedNotification,
        };
      }
      case 'suggest_ecri_approve': {
        return {
          summary: `${data.CreatedBy} suggested to approve the pricing recommendation of £${data.SuggestedPrice}`,
          extraText: `Store: ${data.StoreName} | Tenant: ${data.TenantName} | Unit: ${data.s_unit} `,
          ...formattedNotification,
        };
      }
      case 'suggest_ecri_exclude': {
        let reason = data.Metadata?.reason || '';
        let customReason = data.Metadata?.customReason || '';
        let period = data.Metadata?.period || '';
        return {
          summary: `${data.CreatedBy} suggested to exclude this unit. Reason: ${reason}${customReason ? ' (' + customReason + ')' : ''}. Period: ${period} months.`,
          extraText: `Store: ${data.StoreName} | Tenant: ${data.TenantName} | Unit: ${data.s_unit} `,
          ...formattedNotification,
        };
      }
      case 'override_ecri_price': {
        return {
          summary: `${data.UserName} overrode ECRI price from £${data.OldPrice} to £${data.NewPrice}`,
          extraText: `Tenant: ${data.TenantName} | Unit: ${data.s_unit} | Store: ${data.StoreName}`,
          ...formattedNotification,
        };
      }
      case 'approve_ecri_suggestion': {
        if (data.Type === 'approve') {
          return {
            summary: `${data.ApprovedBy} approved the pricing recommendation of £${data.SuggestedPrice}.`,
            extraText: `Store: ${data.StoreName} | Tenant: ${data.TenantName} | Unit: ${data.s_unit} `,
            ...formattedNotification,
          };
        } else if (data.Type === 'exclude') {
          let reason = data.Metadata?.reason || '';
          let customReason = data.Metadata?.customReason || '';
          let period = data.Metadata?.period || '';

          return {
            summary: `${data.ApprovedBy} excluded this unit from the pricing exercise. Reason: ${reason}${customReason ? ' (' + customReason + ')' : ''}. Period: ${period} months.`,
            extraText: `Store: ${data.StoreName} | Tenant: ${data.TenantName} | Unit: ${data.s_unit} `,
            ...formattedNotification,
          };
        } else {
          return {
            summary: `${data.ApprovedBy} approved ECRI price change from £${data.OldPrice} to £${data.SuggestedPrice}`,
            extraText: `Store: ${data.StoreName} | Tenant: ${data.TenantName} | Unit: ${data.s_unit} `,
            ...formattedNotification,
          };
        }
      }
      default:
        return null;
    }
  });
  return formattedNotifications.filter(Boolean);
};

export const getNotifications = (lastId) => (dispatch) => {
  api
    .getNotifications(lastId)
    .then((res) => {
      if (res.data.notifications.length > 0) {
        const approvedSuggestions = res.data.notifications.filter(
          (notification) =>
            notification.Type === 'approve_suggestion' && notification.data
        );

        const suggestions = res.data.notifications.filter(
          (notification) =>
            notification.Type === 'suggest_price' &&
            notification.data &&
            !(notification.data && notification.data.ApprovedOn)
        );

        const priceUpdates = res.data.notifications.filter((notification) =>
          ['price_update', 'price_override'].includes(notification.Type)
        );

        const discountSuggestions = res.data.notifications.filter(
          (notification) =>
            notification.Type === 'suggest_discount' && notification.data
        );

        const approvedDiscountSuggestions = res.data.notifications.filter(
          (notification) =>
            notification.Type === 'approve_discount_suggestion' &&
            notification.data
        );

        const discountOverrides = res.data.notifications.filter(
          (notification) =>
            notification.Type === 'override_discount' && notification.data
        );

        const ecriSuggestions = res.data.notifications.filter(
          (notification) =>
            notification.data &&
            (notification.Type === 'suggest_ecri_price' ||
              notification.Type === 'suggest_ecri_approve' ||
              notification.Type === 'suggest_ecri_exclude')
        );

        const approvedEcriSuggestions = res.data.notifications.filter(
          (notification) =>
            notification.Type === 'approve_ecri_suggestion' && notification.data
        );

        const ecriOverrides = res.data.notifications.filter(
          (notification) =>
            notification.Type === 'override_ecri_price' && notification.data
        );

        dispatch({
          type: 'UPDATE_SUGGESTIONS',
          payload: {
            suggestions: [...approvedSuggestions, ...suggestions].map(
              (notification) => notification.data
            ),
          },
        });

        approvedSuggestions.forEach((update) => {
          const input = {
            item: {
              id: update.data.PriceId,
              Store: update.Store,
            },
            newPrice: parseFloat(update.data.SuggestedPrice),
            comments: update.data.Comment,
            user: update.data.ApprovedBy,
            override: Boolean(update.data.SuggestedDays),
            overrideDays: update.data.SuggestedDays,
          };

          dispatch({
            type: 'UPDATE_PRICE',
            payload: input,
          });
        });

        priceUpdates.forEach((update) => {
          const input = {
            item: {
              id: update.data.PriceId,
              Store: update.Store,
            },
            newPrice: parseFloat(update.data.NewPrice),
            comments: update.data.comment,
            user: update.data.IsOverride
              ? update.data.override.CreatedBy
              : update.data.UserName,
            override: update.data.IsOverride,
            overrideDays: update.data.IsOverride
              ? update.data.override.OverrideDays
              : null,
          };

          dispatch({
            type: 'UPDATE_PRICE',
            payload: input,
          });
        });

        if (
          discountSuggestions.length > 0 ||
          approvedDiscountSuggestions.length > 0
        )
          dispatch({
            type: 'UPDATE_DISCOUNT_SUGGESTIONS',
            payload: {
              suggestions: [
                ...discountSuggestions,
                ...approvedDiscountSuggestions,
              ].map((notification) => notification.data),
            },
          });

        if (discountOverrides.length > 0)
          dispatch({
            type: 'UPDATE_DISCOUNT_OVERRIDES',
            payload: {
              overrides: discountOverrides.map(
                (notification) => notification.data
              ),
            },
          });

        if (ecriSuggestions.length > 0 || approvedEcriSuggestions.length > 0)
          dispatch({
            type: ECRI_ACTIONS.UPDATE_IN_LEASE_PRICE_SUGGESTIONS,
            payload: {
              suggestions: [...ecriSuggestions, ...approvedEcriSuggestions].map(
                (notification) => notification.data
              ),
            },
          });

        if (ecriOverrides.length > 0)
          dispatch({
            type: ECRI_ACTIONS.UPDATE_IN_LEASE_PRICE_OVERRIDES,
            payload: {
              overrides: ecriOverrides.map((notification) => notification.data),
            },
          });

        let notifications = formatNotification(res.data.notifications);
        if (lastId !== 0) {
          res.data.notifications.forEach((not) => {
            dispatch({
              type: 'NOTIFICATION_TYPE',
              payload: not,
            });
          });
        }
        notifications.forEach((notification) => {
          if (!notification.read && notification.data.isToday) {
            dispatch({
              type: 'SHOW_NOTIFICATION',
              payload: {
                type: 'info',
                message: notification.summary,
                title: notification.extraText,
                id: notification.id,
                notificationData: notification.data,
              },
            });
          }
        });
        dispatch({
          type: 'NOTIFICATIONS',
          payload: notifications,
        });
      }
    })
    .catch((err) => {
      console.log('error ', err);
      // if (err.response.status === 401)
      //     dispatch({
      //         type: 'LOGOUT'
      //     })
      // else
      //     dispatch({
      //         type: 'API_ERROR',

      //     })
    });
};

export const markNotificationsRead = (ids) => (dispatch) => {
  if (ids.length > 0) {
    api
      .markNotificationsRead(ids)
      .then((res) => {
        dispatch({
          type: 'MARK_READ',
          payload: ids,
        });
      })
      .catch((err) => {
        console.log('error', err.message);
      });
  }
};
